import { Divider } from "$root/components/Divider";
import { StackContextBlock } from "$root/components/common/Stack";
import { SidePanelListItem } from "$root/functional-areas/workspace/ui/SidePanelItem";
import { DraggableSettingsPanel } from "$root/ui-lib/DraggableSettingsPanel";
import { Column, Row } from "@mdotm/shadcn/legacy/components";
import { useMandatoryContext } from "@mdotm/utils/react-extra";
import type { ReactNode } from "react";

type ColumnItem = { colId: string; hide: boolean; label: string };

type ColumnSettingsPanelProps = {
	title: string;
	description: string;
	columnState: ColumnItem[];
	onChange: (columns: { colId: string; hide: boolean }[]) => void;
	emptyState?: ReactNode;
};

export function ColumnSettingsPanel({
	title,
	description,
	columnState,
	onChange,
	emptyState,
}: ColumnSettingsPanelProps) {
	const stackCtx = useMandatoryContext(StackContextBlock);

	function handleToggle(colId: string, visible: boolean) {
		onChange(
			columnState.map((c) =>
				c.colId === colId ? { colId: c.colId, hide: !visible } : { colId: c.colId, hide: c.hide },
			),
		);
	}

	function handleReorder(newItems: ColumnItem[]) {
		onChange(newItems.map((c) => ({ colId: c.colId, hide: c.hide })));
	}

	return (
		<DraggableSettingsPanel
			title={title}
			description={description}
			onBack={{ icon: "Left", action: () => stackCtx.pop() }}
			items={columnState}
			itemKey={(item) => item.colId}
			onReorder={handleReorder}
			searchExtract={(item) => item.label}
			emptyState={emptyState}
		>
			{(item, { dragIcon, isDragging }) => (
				<Column className="overflow-hidden">
					<Row gap={8} alignItems="center">
						{dragIcon}
						<SidePanelListItem
							title={item.label}
							checked={!item.hide}
							onToggle={(visible) => handleToggle(item.colId, visible)}
						/>
					</Row>
					{!isDragging && <Divider className="border-dashed" />}
				</Column>
			)}
		</DraggableSettingsPanel>
	);
}
